const adminMenus = [
  {
    id: "dashboard",
    link: "/",
    label: "Дашборд",
    icon: "menu-analytic",
  },

  {
    id: "organizations",

    label: "Организации",
    icon: "menu-hr",
    children: [
      {
        id: "accounts",
        link: "/accounts",
        label: "Аккаунты",
      },
      {
        id: "organizations",
        label: "Организации",
        link: "/organizations",
      },
      {
        id: "organization-tasks",
        label: "Задачи по организациям",
        link: "/organization-tasks",
      },
      {
        id: "organization-task-statistics",
        label: "Статистика по задачам",
        link: "/organization-task-statistics",
      },

      {
        id: "organization-status",
        link: "/organization-status",
        label: "Статус Организации",
      },
      {
        id: "offline-jobs",
        link: "/offline-jobs",
        label: "Офлайн синхронизация",
      },
    ],
  },

  {
    id: "admin-organizations",
    link: "/admin-organizations",
    label: "Филиал",
    icon: "menu-analytic",
  },
  {
    id: "departments",
    link: "/departments",
    label: "Отделы",
    icon: "menu-analytic",
  },
  {
    id: "reports",
    label: "Отчеты",
    icon: "menu-report",
    children: [
      {
        id: "reports/debt-credit",
        link: "/reports/debt-credit",
        label: "Дебиторы и кредиторы",
        role: "debt_credit",
      },
      {
        id: "reports/products",
        link: "/report/products",
        label: "Отчёт по продуктам",
        role: "monitoring_by_dishes",
      },
      {
        id: "reports/products/count",
        link: "/report/products/count",
        label: "Отчёт по количествам продуктов",
        role: "monitoring_by_dishes",
      },
    ],
  },
  {
    id: "storages",
    label: "Склад",
    icon: "menu-storage",
    children: [
      {
        id: "incomes",
        link: "/storage/incomes",
        label: "Приход товаров",
      },
      {
        id: "consumption",
        link: "/storage/consumption",
        label: "Расход товаров",
      },
      {
        id: "storages",
        link: "/storages",
        label: "Остаток",
      },
      {
        id: "comings",
        link: "/storage/comings",
        label: "Журнал приходов",
      },
      {
        id: "transfer",
        link: "/storage/transfers",
        label: "Перемещение",
      },
      {
        id: "comings",
        link: "/storage/comings?is_trash=1",
        label: "Отход Товаров",
        role: "comings",
      },
      {
        id: "adjustments",
        link: "/storage/adjustments",
        label: "Инвентаризация",
        role: "adjustments",
      },
    ],
  },
  {
    id: "nomenclature",
    label: "Номенклатура",
    icon: "menu-storage",
    cols: 5,
    children: [
      {
        id: "materials",
        link: "/materials",
        label: "Продукт",
      },
      {
        id: "materialsTwo",
        link: "/materialsTwo",
        label: "Продукт Б/У",
      },
      {
        id: "product-category",
        link: `/categories`,
        label: "Категория реализации",
      },
      {
        id: "orders",
        link: "/orders",
        label: "Заказы ",
      },
      {
        id: "units",
        label: "Единица измерения",
        link: "/units",
      },
    ],
  },
  {
    id: "lead",
    label: "Маркетинг",
    icon: "menu-hr",
    children: [
      {
        id: "leads-online",
        link: "/leads/online",
        label: "Лиды Online",
      },
      {
        id: "leads-offline",
        link: "/leads/offline",
        label: "Лиды Offline",
      },
      {
        id: "leads-hr",
        link: "/leads/hr",
        label: "Лиды HR",
      },
      {
        id: "leads-new",
        link: "/leads-new",
        label: "Лиды (Встречи)",
      },
      {
        id: "leads-status",
        link: "/lead-status",
        label: "Статус лида",
      },
      {
        id: "lead-cancellation",
        link: "/lead-cancellation",
        label: "Причины отмены лида",
      },
      {
        id: "lead-tags",
        link: "/lead-tags",
        label: "Теги лида",
      },
      {
        id: "leads-statistics",
        link: "/leads-statistics",
        label: "Лиды статистика",
      },
    ],
  },

  {
    id: "handbooks",
    label: "Справочники",
    icon: "menu-handbook",
    children: [
      {
        id: "handbook-country",
        label: "Страны",
        link: "/handbook/country",
      },
      {
        id: "handbook-regions",
        label: "Регионы",
        link: "/handbook/regions",
      },
      {
        id: "handbook-districts",
        label: "Районы",
        link: "/handbook/districts",
      },
      {
        id: "targets",
        label: "Таргеты",
        link: "/targets",
      },
    ],
  },
  {
    id: "service",
    label: "Услуга",
    icon: "menu-setting",
    children: [
      {
        id: "statistics",
        link: "/task-statistics",
        label: "Статистика задач",
      },
      {
        id: "employees",
        link: "/employees",
        label: "Сотрудники",
      },
      {
        id: "employees-on-map",
        link: "/employees-on-map",
        label: "Сотрудники на карте",
      },
      {
        id: "source",
        link: "/source",
        label: "Источник",
      },
      {
        id: "service",
        link: "/service",
        label: "Услуга",
      },
      {
        id: "tech-help",
        link: "/tech-help",
        label: "Обратная связь",
      },
    ],
  },
  {
    id: "hamkorbank",
    label: "Хамкорбанк",
    icon: "menu-finance",
    children: [
      {
        id: "transactions-bank",
        link: "/transactions-bank",
        label: "Хамкорбанк статистика",
      },
      {
        id: "transactions-hamkorbank",
        link: "/transactions-hamkorbank",
        label: "Хамкорбанк транзакция",
      },
    ],
  },

  {
    id: "finance",
    label: "Финансы",
    icon: "menu-finance",
    children: [
      {
        id: "counterparties",
        link: "/counterparties",
        label: "Клиенты",
      },
      {
        id: "transactions",
        link: "/transactions-finance",
        label: "Денежные операции",
      },
      {
        id: "category/income",
        link: "/transactions/categories/income",
        label: "Категория приходов",
      },
      {
        id: "category/expense",
        link: "/transactions/categories/expense",
        label: "Категория расходов",
      },
      {
        id: "payment-types",
        link: "/payment-types",
        label: "Способ оплаты",
      },
      {
        id: "history",
        link: "/history",
        label: "История изменений",
      },
      {
        id: "debt-payment-split",
        link: "/debt-payment-split",
        label: "Разделение расход",
      },
      {
        id: "finance-templates",
        link: "/finance-templates",
        label: "Шаблоны расходов",
      },
      {
        id: "expense-requests",
        link: "/expense-requests",
        label: "Траты сотрудников",
      },
      {
        id: "admin-transactions",
        link: "/admin-transactions",
        label: "Баланс администраторов",
      },
    ],
  },
  {
    id: "tasks",
    label: "Задачи",
    icon: "menu-finance",
    children: [
      {
        id: "task-board",
        link: "/task-board",
        label: "Задачи",
      },
      {
        id: "approvals",
        link: "/approvals",
        label: "Модерация задач",
      },
    ],
  },
  {
    id: "ratings",
    link: "/ratings",
    label: "Рейтинг",
    icon: "menu-analytic",
  },

  {
    id: "settings",
    label: "Настройки",
    icon: "menu-finance",
    children: [
      {
        id: "lagnuages",
        link: "/languages",
        label: "Языки",
        icon: "menu-finance",
      },
      {
        id: "translation",
        link: "/translation",
        label: "Переводы",
        icon: "menu-finance",
      },
      {
        id: "store",
        link: "/store",
        label: "Zim-zim Store",
        icon: "menu-finance",
      },
      {
        id: "imageBackground",
        link: "/image-background",
        label: "Фон для кассира",
        icon: "menu-finance",
      },
      {
        id: "user-log",
        link: "/user-log",
        label: "Лог пользователя",
        icon: "menu-finance",
      },
    ],
  },
];

const getMenu = (role) => {
  switch (role) {
    case "admin":
      return adminMenus;
    default:
      return [];
  }
};

export default getMenu;
